require("./bootstrap");

window.Vue = require("vue");

import Vue from "vue";
import Vuelidate from "vuelidate";
import VeeValidate from 'vee-validate';
import VueLazyload from "vue-lazyload";
import VueI18n from "vue-i18n";
import router from "./frontend/router";

Vue.use(Vuelidate);
Vue.use(VueI18n);

Vue.use(VeeValidate);

function loadLocalMessages() {
    const locales = require.context(
        "../../src/locales",
        true,
        /[A-za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};

    locales.keys().forEach(key => {
        const matched = key.match(/([A-za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });

    return messages;
}

const i18n = new VueI18n({
    locale: process.env.MIX_VUE_APP_I18N_LOCALE || "cs", //Set locale
    fallbackLocale: process.env.MIX_VUE_APP_I18N_FALLBACK_LOCALE || "en", //Set fallback locale
    messages: loadLocalMessages() //Set locale messages
});

Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1,
    loading: "/images/lazyimg.jpg?tr=h-1,w-1:w-400,h-300",
    listenEvents: ["scroll"]
});

Vue.component(
    "slider",
    require("./frontend/components/slider/Slider.vue").default
);

Vue.filter("striphtml", function(value) {
    var div = document.createElement("div");
    div.innerHTML = value;
    var text = div.textContent || div.innerText || "";
    return text;
});

const app = new Vue({
    el: "#app",
    i18n,
    router
});



